/** Asks the phone for files: its camera (a photo taken now), its photos, or its files. */
export function pickFiles(
  source: 'camera' | 'photos' | 'files',
  onPicked: (files: FileList) => void,
): void {
  const input = document.createElement('input');
  input.type = 'file';
  if (source !== 'files') input.accept = 'image/*';
  if (source === 'camera') input.setAttribute('capture', 'environment');
  else input.multiple = true;
  input.addEventListener('change', () => {
    if (input.files !== null && input.files.length > 0) onPicked(input.files);
  });
  input.click();
}
